import { useLanguage } from "../../context/LanguageContext";

// Shared by CatalogToolbar (desktop, always-visible toolbar) and
// CatalogSidebar (mobile filter drawer) — same control, different home
// depending on viewport width. See each call site for why.
export default function InStockSwitch({
  checked,
  count,
  onChange,
}: {
  checked: boolean;
  count: number;
  onChange: (next: boolean) => void;
}) {
  const { t } = useLanguage();
  if (!checked && count === 0) return null;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className="flex items-center gap-2"
    >
      {/* Square, not pill-shaped — every other toggle-like control on this
          site (filter chips, the sort dropdown, the search bar) is a sharp
          rectangle, not a rounded one, so this switch matches rather than
          being the one rounded outlier. */}
      <span
        className={`relative inline-flex h-5 w-9 shrink-0 border transition-colors duration-200 ease-engineered ${
          checked ? "border-accent bg-accent" : "border-steel-300 bg-white"
        }`}
      >
        <span
          className={`absolute left-0.5 top-0.5 h-3.5 w-3.5 transition-transform duration-200 ease-engineered ${
            checked ? "translate-x-4 bg-white" : "translate-x-0 bg-steel-400"
          }`}
        />
      </span>
      <span className="text-xs text-steel-600 sm:text-sm">{t("inStockBadge")}</span>
    </button>
  );
}
